import { isANumber, convertDigitToProperFormat } from 'utils/number';
import { getLanguageBaseOnTZ } from '../../../../../utils/LanguageLocalStorage';
import i18n from '../../../../../i18n';

export default {
  relatedDistricts: 'واحد / بخش مربوطه',
  initialConfigs: 'تنظیمات پایه',
  questionList: 'لیست سؤالات این پرسش‌نامه: ',
  indicatorQuestion: 'عنوان شاخص',
  addQuestion: 'ایجاد سؤال جدید',
  addOption: 'افزودن گزینه جدید',
  close: 'بستن',
  edit: 'سوالات',
  save: 'ذخیره',
  cancel: 'لغو',
  delete: 'حذف',
  keep: 'نگه داشتن',
  confirm: 'ذخیره',
  // Questions
  correctAnswer: 'پاسخ درست',
  file: 'فایلی',
  allSubTagsOf: 'همه‌ی بخش‌هایی که زیرمجموعه‌ی یکی از بخشهای زیر هستند:',
  excludedTags: ' به جز :',
  allTags: 'همه بخش ها',
  divideSections: 'شاخص به تفکیک بخش تکمیل می‌شود',
  fillAccess: 'تکمیل فقط توسط مسئول بخش مربوطه',
  reportAccess: 'مشاهده و گزارش فقط توسط مسئول بخش مربوطه ',
  sectionOrUnit: 'بخش/واحد',
  hospital: 'بیمارستان',
  savedSuccessfully: 'تنظیمات بروزرسانی شد.',
  grid: 'جدولی',
  text: 'متنی',
  indicator: 'شاخص',
  multipleChoice: 'چند گزینه‌ای',
  multipleAnswer: 'چند پاسخه',
  removeResponseTitle: 'حذف پاسخ',
  restoreQuestion: 'بازیابی سؤال پاک شده',
  show: 'نمایش بده',
  hide: 'پنهان‌ کن',
  createNewVersion: 'ساخت نسخه جدید',
  create: 'ایجاد',
  versionTitle: 'عنوان نسخه',
  versionDescription: 'توضیح نسخه',
  creationDate: 'تاریخ ایجاد',
  activeVersion: 'فعال',
  makeActive: 'انتخاب به عنوان نسخه فعال',
  newVersionInfoTitle: 'نکات مربوط به ساخت نسخه جدید',
  newVersionInfo:
    'در صورتی که پرسشنامه تغییر کرده است و شما می خواهید این تغییرات را در پرسشنامه ایجاد کنید در صورتی که قبلا پاسخ‌هایی در این پرسشنامه ارسال شده باشد باید تغییرات را در نسخه جدیدی از پرسشنامه اعمال کنید تا پاسخ های قبلی طبق نسخه خودشان مورد ارزیابی قرار گیرند. ' +
    '\n در هنگامی که نسخه جدید می‌سازید اتفاقات زیر رخ می‌دهد ' +
    '\n ۱. نسخه قبلی پایدار می‌شود و تغییرات جدید در آن اعمال نمی شود (مگر در مواردی که اعلام می شود) به عبارت دقیق تر ' +
    '\n - سوالات و گامها و گزینه‌ها ثابت می‌شوند ' +
    '\n -  لیست گزارش های موجود در نسخه ذخیره می‌شود تا در صورت نیاز بعدا قابل مشاهده باشد.' +
    '\n ۲. تغییرات پرسشنامه تنها بر روی آخرین نسخه قابل انجام است و نسخه‌های قبلی قابل تغییر نیستند ' +
    '\n ۳. ویرایش گزارشات بر روی همه نسخه ها اعمال می‌شود اما می توانید برخی از گزارش‌ها را حذف یا اضافه کنید که تنها بر روی نسخه نهایی اعمال می‌شود ' +
    '\n ۴. تنها می توان به نسخه فعال پاسخ ارسال کرد اما امکان تغییر نسخه فعال در هر زمان وجود دارد.',
  canNotChangeNotActiveVersion: 'امکان تغییر بر روی نسخه غیر فعال وجود ندارد',
  availableConfigs:
    'لیست کانفیگ‌های موجود:' +
    ' conf_submitSuccessMessage, ' +
    ' conf_submitSuccessActionTitle, ' +
    ' conf_submitSuccessActionUrl, ' +
    ' conf_newResponse, ' +
    ' conf_allowDraft, ' +
    ' conf_addDescriptionTitle, ' +
    ' conf_uniquePerDevice, ' +
    ' conf_openNextOnFill, ' +
    ' conf_shouldOpenNextMessage, ' +
    ' conf_signOutOnFill, ' +
    ' conf_allowAnonymousUsers, ' +
    ' conf_skipSurveyTag, ' +
    ' conf_emptyMessage, ' +
    ' conf_excludeDetailedGridReports, ' +
    ' conf_reportNamePrefix, ' +
    ' conf_relatedUserTitle, ' +
    ' conf_loginMessage, ' +
    ' conf_openHints, ' +
    ' conf_nonNumbering ' +
    ' conf_dataSource ',
  availableConfigs_simple: 'لیست کانفیگ‌های موجود:' + ' conf_allowDraft, ',
  appliedRoles: 'نقش‌ها/سمت‌های مرتبط',
  addRoles: 'افزودن سمت',
  visibility_open: 'امکان ثبت پاسخ برای همه',
  visibility_protected: 'امکان ثبت پاسخ برای افراد با دسترسی تغییر داده',
  visibility_personal:
    'امکان ثبت پاسخ شخصی (فرد برای خودش بتواند پاسخ ثبت کند)',
  visibilityStrategy: 'محدودیت‌ ثبت پاسخ برای افراد',
  showResponseToTarget: 'نمایش پاسخ های مرتبط با هر فرد به خود فرد',
  addNotification: '+ افزودن اعلان',
  addNotifGroup: '+ افزودن گروه هدف اعلان',
  SMS: 'پیامک',
  medium: 'بستر',
  action: 'عملیات',
  changedQuestion: 'سوال',
  changedQuestionValue: 'پاسخ',
  Submit: 'ارسال',
  Update: 'به روز رسانی',
  Draft: 'پیشنویس',
  Undraft: 'مصوب',
  DraftSubmit: 'ارسال پیشنویس',
  Lock: 'قفل',
  Unlock: 'بازگشایی',
  UpdateByAdmin: 'به روز رسانی مدیر',
  AnswerChanged: 'تغییر پاسخ',
  messagePattern: 'الگوی پیام',
  targetUser: 'دریافت کننده',
  sender: 'ارسال کننده پاسخ',
  relatedUser: 'کاربر مرتبط ',
  fixedPerson: 'فرد مشخص',
  targetUserType: 'نوع دریافت کننده',
  copyLink: 'کپی شناسه',
  availableMessagePatterns: '',
  keepLatestInstanceIfAnonymous: 'نگهداری آخرین نمونه ناشناس',
  stageQuestion: 'سوال مرحله',
  reindexNote:
    'با درخواست به روز رسانی گزارش‌ها، تمام پاسخ‌ها با توجه به تنظیمات کنونی پرسشنامه (و یا تنظیمات اخر نسخه مربوط به خودشان) اندیس گذاری می‌شوند این کار ممکن است با توجه به تعداد پاسخ‌ها چندین دقیقه طول بکشد و در این مدت گزارش ها در دسترس نخواهد بود.' +
    '\n' +
    'به روز رسانی در حالات زیر نیاز است' +
    '\n' +
    '۱. تغییر در امتیاز سوالات یا وزن آن‌‌ها' +
    '\n' +
    '۲. تغییر در برچسب سوالات یا پرسشنامه' +
    '\n' +
    '۳. تغییر نحوه‌ی محاسبه‌ی امتیاز پرسشنامه' +
    '\n' +
    '۴. تغییر گزینه ی ادغام مجموع و تعداد در سوال جدولی',
  reIndexResponses: 'به روز رسانی گزارش‌ها',
  sensitiveChangeRequiresEditor:
    'نیازمند دسترسی ویرایش برای حذف / باز گشایی قفل پاسخ',
  restrictionOfCompletion: 'محدودیت بازه تکمیل',
  startOffset: 'تعداد روز بعد از شروع بازه',
  endOffset: 'تعداد روز بعد از پایان بازه',
  conditionQuestion: 'سوال شرط',
  notifGroupTitle: 'گروه هدف اطلاع رسانی',
  notifGroups: 'گروه‌های اطلاع رسانی',
  allowEditNotifGroupMembersTo: 'امکان ویرایش گروه هدف نوتیف توسط کاربران زیر',
  users: 'کاربران',
  defaultPeriodType: ' (بازه پیشفرض پرسشنامه)',
  Slack: 'کانال اسلک',
  slackABC: 'کانفیگ هوک اسلک A/B/C',
  roles: 'سمت',
  selectRole: 'انتخاب نقش',
  uniquePerTags: 'یکتا به ازای دوره آموزشی',
  keepSubmitQuestionList:
    'در هنگام به روز رسانی پاسخ لیست سوالات در هنگام ارسال در نظر گرفته شود و سایر سوالات در نظر گرفته نشوند',
  randomizeOrder: 'چینش تصادفی سوالات و گزینه‌ها',
  enabled: 'فعال',
  randomizeEnabledQuestions: 'فعال سازی تصادفی سوالات',
  activeQuestionCount: 'تعداد سوالات فعال',
  convertToClassRating: 'تبدیل به ارزشیابی',
  surveyConvertedToExam:
    'پرسشنامه به آزمون تبدیل شد. با این حال ممکن است برخی ویژگی ها نیاز به تغییر داشته باشد.',
  confirmConvertToExam:
    'ایا مطمئن هستید که این می‌خواهید این چکلیست به یک آزمون تبدیل شود؟',
  identification: 'شناسنامه',
  otherTags: 'سایر پرچسب‌ها',
  createCopy: 'ایجاد کپی',
  copyToClipboard: 'کپی در حافظه',
  addToClibpard: 'افزودن به حافظه',
  enterQuestionTitle: 'عنوان سوال کپی را وارد کنید',
  copyQuestion: 'کپی سوال',
  useQuestionBank: 'استفاده از بانک سوالات',
  managePhoneDirectAcceess: ' لیست دسترسی مستقیم',
  addToPhoneValidList: 'افزودن به لیست',
  validListUpdated: 'موارد به لیست شماره های مجاز اضافه شدند',
  validListInfo:
    'افرادی که شماره های آنها در این لیست اضافه می شوند در صورتی که عضو مجموعه نباشند نیز می‌توانند به این پرسشنامه پاسخ دهند',
  removeValidList: 'حذف لیست شماره های مجاز',
  removeValidListConfirm:
    'با حذف این لیست هر فرد با دسترسی به پرسشنامه امکان پاسخ به آن را دارد',
  currentListCount: 'تعداد شماره ثبت شده',
  validListRemoved: 'لیست دسترسی حذف شد',
  active: 'فعال',
  inactive: 'غیر فعال',
  enterPhoneNumber: 'شماره تلفن افراد مورد نظر را وارد کنید ',
  pleaseUseANewVersion:
    'لطفا نسخه جدیدی برای این پرسشنامه بسازید و آن را به سایر تحلیل ها اعمال کنید.',
  confirmApplyAnalyseTemplate:
    'ایا از اعمال این قالب تحلیل به همه تحلیل های موجود در این مجموعه اطمینان دارید؟ کلیه ویژگی های این پرسشنامه از قبلی قفل خودکار / تاریخچه تغییر و ... به جز موارد مربوط به اعلان‌ها به همه تحلیل ها اعمال می‌شود. همچنین مطمئن شوید که در صورت لزوم تغییرات را در نسخه جدید ایجاد می‌کنید.',
  applyAnalyseTemplate: 'اعمال قالب تحلیل به همه‌ی تحلیل ها',
  analyseTemplateApplied: 'قالب تحلیل به سایر تحلیل ها اعمال شد',
  numeratorQuestion: 'صورت شاخص',
  numeratorUnit: 'واحد صورت شاخص',
  denominatorQuestion: 'مخرج شاخص',
  denominatorUnit: 'واحد مخرج شاخص',
  analyseSplit: 'تفکیک تحلیل',
  required: 'الزامی',
  withoutDenominator: 'بدون مخرج',
  pleaseSelectAValue: 'لطفا مقداری وارد کنید',
  districtSplitHint:
    'در صورتی که این شاخص به تفکیک بخش تکمیل نمی‌شود بخش مربوط به این شاخص (متولی) را وارد کنید',
  percent: 'درصد',
  destrictConfiguration: 'تنظیمات بخش',
  changeTypeWarning:
    'تغییر در نوع شاخص ( تجمیعی یا کسری ) باعث تغییر در کل شاخص و گزارش های آن می‌شود و در صورتی که داده ای قبلا در آن وارد شده باشد در گزارشها اشتباه نشان داده خواهد شد. لطفا در این شرایط شاخص جدیدی تعریف کنید',
  editableOnlyBySupport:
    'تنها امکان تغییر شناسنامه شاخص وجود دارد. برای ویرایش تنظیمات این شاخص تیکت پشتیبانی ثبت کنید.',
  noValidPeriodAvailable: 'امکان ثبت در هیچ بازه ای وجود ندارد',
  importedSuccessfully: 'فایل ورودی به صورت موفقیت آمیز ثبت شد',
  addImportedQuestion: 'افزودن سوالات به لیست پرسشنامه',
  questionsAddedToSurvey: 'سوالات با موفقیت به بخش پرسشنامه اضافه شد.',
  questionsFailedToSurvey:
    'افزودن سوالات به بخش پرسشنامه به مشکل مواجه شده است.',

  pasteCopiedQuestion: (count: number | string) => {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa'
      ? `جایگذاری ${count} سوال کپی شده`
      : `Paste ${count} copied questions`;
  },
  questionCopied: (count: number) => {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa'
      ? `${convertDigitToProperFormat(count)} سوال کپی شد`
      : `${convertDigitToProperFormat(count)} copied successfully`;
  },
  indexed(num: number) {
    return `${num} پاسخ اندیس گذاری شد`;
  },
  versionCreatedSuccessfully(name: string) {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa'
      ? `نسخه ${name} ساخته شد`
      : `${name}'s version created successfully`;
  },

  deletedQuestion(count: number) {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa'
      ? `${count} سؤال حذف شده وجود دارد. `
      : `There are ${count} deleted questions`;
  },
  copiedQuestion(title: string) {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa' ? `${title} (کپی)` : `Copy ${title}`;
  },
  viewResponse: 'مشاهده‌ی نتایج',
  settings: 'تنظیمات',
  versions: 'نسخه‌ها',
  selectTag: 'انتخاب بخش',
  enterTags:
    'لطفا برچسب‌های که می‌خواهید پاسخ مربوط به این پرسش‌نامه با آن مشخص گردد، را مشخص کنید.',
  saveGeneralItems: 'ذخیره‌ی موارد کلی',
  answersSettings: 'تنظیمات مربوط به پاسخ‌ها',
  surveyName: 'عنوان پرسش‌نامه',
  surveyDescription: 'توضیحات کلی',
  chart: 'گزارش‌ها',
  analyse: 'تحلیل‌ها',
  singleAnalyse: 'تحلیل',
  recommendRefill:
    'آیا پس از پر کردن پرسش‌نامه پیشنهاد دوباره پر کردن آن به کاربر داده شود؟',
  drag: 'جابجایی',
  copying: 'کپی',
  responses: 'پاسخ‌ها',
  addDescription: '+ اضافه کردن توضیحات بیشتر',
  autoLock: 'قفل خودکار',
  periodType: ' بازه زمانی ورود داده',
  analysedPeriodType: 'بازه زمانی تحلیل: ',
  disabled: 'غیرفعال',
  day: 'روزانه',
  week: 'هفتگی',
  month: 'ماهانه',
  season: 'فصلی',
  twoSeason: 'نیم‌سال',
  year: 'سالانه',
  surveyUpdated: 'پرسش‌نامه با موفقیت به‌روزرسانی شد',
  keepUnique: 'پاسخ‌ها یکتا باشد',
  uniquePerUser: 'پاسخ‌ها بر اساس ارسال کننده یکتا باشد',
  keepResponsesAnonymous: 'ثبت پاسخ به صورت ناشناس',
  uniquePerTime: 'پاسخ‌ها بر اساس زمان یکتا باشد',
  uniquePerInstance: 'پاسخ‌ها بر اساس هویت/کاربر مرتبط یکتا باشند',
  instanceType: 'نمونه‌ی پرسش‌نامه',
  providerItemId: 'بر اساس آیتم',
  providerId: 'بر اساس هویت',
  user: 'به تفکیک کاربران عضو',
  askTitle: 'ثبت عنوان',
  offerToFillAtFirst: 'نمایش پرسشنامه در هنگام باز کردن',
  trackResponseChanges: 'نگه‌داری تغییرات در پاسخ',
  name: 'عنوان',
  value: 'مقدار',
  mergeSumAndCount: 'ادغام مجموع و تعداد',
  checkPoints: 'اهداف کلی',
  scoreMethod: 'نحوه‌ی محاسبه‌ی امتیاز پرسشنامه',
  sum: 'جمع',
  totalAverage: 'میانگین کل',
  otherSplit: 'شاخص به تفکیکی به جز بخش تکمیل می‌شود ',
  otherSplitTitle: 'عنوان تفکیک دیگر',
  analyseSetting: 'تنظیمات تحلیل',
  currentStatus: 'وضعیت کنونی :',
  audio: 'فایل صوتی',
  video: 'فیلم',
  image: 'عکس',
  document: 'اسناد',
  compressed: 'فایل فشرده',
  importFromExcel: 'افزودن سوال از روی اکسل',
  errorInImportingExcel: 'خطا در دریافت فایل ورودی اکسل',
  questionListFromExcel: 'لیست سوالات ورودی از اکسل',
  isRepeatedQuestion: 'سوال تکراری',
  questionExistUseNewId(title: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `سوال «${title}» وجود دارد ایا تمایل دارید سوال جدیدی ایجاد شود`;
    else
      return `The question «${title}» already exists. Would you like to create a new question?`;
  },

  validListCount(count: number | null) {
    if (!isANumber(count))
      return (
        this.currentStatus + 'هر فرد با دسترسی به پرسشنامه امکان تکمیل دارد'
      );
    return (
      this.currentStatus +
      `تنها ${convertDigitToProperFormat(count!)} فرد مشخص شده و یا افراد دارای دسترسی در شرکت امکان تکمیل پارسخ دارند`
    );
  },
  evaluatedMetric(evaluatedMetric: string) {
    return i18n.t('evaluatedMetric', { ns: 'survey', evaluatedMetric });
  },
};

export const definedTypes: { [type: string]: string } = {
  audio: 'فایل صوتی',
  video: 'فیلم',
  image: 'عکس',
  document: 'اسناد',
  compressed: 'فایل فشرده',
};
